var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("This is the admin person "+_vm._s(this.$route.params.pid)+" page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }